import { AlertTriangleIcon, Icon, View } from 'smoothie';

interface AccountStateProps {
    state: 'error';
    size?: 'sm' | 'lg';
}

const AccountStateIcon = ({ state, size }: AccountStateProps) => {
    const padding = size === 'lg' ? 10 : 6;
    const iconSize = size === 'lg' ? 16 : 12;

    switch (state) {
        case 'error':
            return (
                <View
                    backgroundColor="$red200"
                    padding={padding}
                    borderRadius={100}
                >
                    <Icon
                        icon={AlertTriangleIcon}
                        color="$red1000"
                        size={iconSize}
                    />
                </View>
            );
        default:
            return <></>;
    }
};

export default AccountStateIcon;
